import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * Decide whether or not to allow sticky Column.
  */
  sticky: PropTypes.bool
};
var Row = createComponent({
  displayName: 'Row',
  root: 'div',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      return ['swan-row', props.sticky ? 'swan-row-sticky' : ''];
    }
  }
});
Row.defaultProps = {
  sticky: false
};
export { Row };